import React, { Component } from 'react'

import Colors from 'material-ui/styles/colors'
import TextField from 'material-ui/TextField'
import AutoComplete from 'material-ui/AutoComplete';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import Divider from 'material-ui/Divider'
import {List, ListItem} from 'material-ui/List'

import StarsRating from 'components/StarsRating'
import Checkbox from 'material-ui/Checkbox'

// const categories = [
// 	"Real Estate Agents"
//   , "Real Estate Services"
// ]

export default (o) => (
	<div>
		<header
			style={{
				width: "100%"
			  , height: "60px"
			  , top: "0"
			  , zIndex: "5555"
			  , backgroundColor: "#00ACC1"
			  , position: "fixed"
			  , lineHeight: "60px"
			}}
			className="action-bar"
		>
			<div
				style={{
					width: "inherit"
				  , height: "inherit"
				  , textAlign: "center"
				}}
			>
				<span
					style={{
						display: "inline-block"
					  , position: "absolute"
					  , left : "4px"
					}}
					onClick={()=> o.setState("")}
				>
					<svg
						width="16px"
						height="16px"
						viewBox="0 0 17 17"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink"
						style={{
							verticalAlign: "middle"
						  , marginLeft: "12px"
						  , cursor: "pointer"
						  , paddingBottom: "3px"
						  , marginRight: "5px"
						}}
					>
						<title>Group</title>
						<defs></defs>
						<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
							<g id="Group" transform="translate(1.000000, 1.000000)" stroke="#909090" strokeWidth="2">
								<path d="M0.5,0.5 L14.5356684,14.5356684" id="Line"></path>
								<path d="M0.5,0.5 L14.5356684,14.5356684" id="Line" transform="translate(7.500000, 7.500000) scale(-1, 1) translate(-7.500000, -7.500000) "></path>
							</g>
						</g>
					</svg>
					General info
				</span>
				{/*
				<span
					style={{
						overflow: "hidden"
					  , textOverflow: "ellipsis"
					  , whiteSpace: "nowrap"
					  , display: "inline-block"
					  , width: "50%"
					  , verticalAlign: "middle"
					  , marginLeft: "8%"
					}}
				>
					Edit
				</span>
				*/}
			</div>
		</header>
		<div
			style={{
				padding: "70px 20px 30px 10px"
			}}
		>
			<TextField
				style = {{marginLeft: "5px", marginTop: "-15px"}}
				fullWidth={true}
				className={(typeof global.md.phone() == 'string')? "company-name" : ""}
				defaultValue = {o.agent.firstName}
				key={`${o.agent._id}-company`}
				inputStyle={{fontSize: "16"}}
				onBlur={(evt)=>
					(evt.target.value.length)?
						o.docUpd({
							_id: o.agent._id
						  , firstName: evt.target.value
						  , comments: (!o.agent.comments)?
								[{
									userID: o.login.userID
								  , auto: true, body: 'Change company name'
								  , date: new Date().valueOf()
								  , value: evt.target.value
								}]
								: [
									...o.agent.comments
								  , {
										userID: o.login.userID
									  , auto: true, body: 'Change company name'
									  , date: new Date().valueOf()
									  , value: evt.target.value
									}
								]
						})
						: false
				}
			/>
		</div>
		<StarsRating
			style={{marginLeft: "12px", marginTop: "0px"}}
			value = {(o.agent.rating)? o.agent.rating:"0"}
			clickable = {true}
			className={(typeof global.md.phone() == 'string')? "company-rating" : ""}
			onChange = {(value) =>
				o.docUpd({
					_id: o.agent._id
				  , rating: value
				  , comments: (!o.agent.comments)?
						[{
							userID: o.login.userID
						  , auto: true, body: 'Change rating'
						  , date: new Date().valueOf()
						  , value: value
						}]
						: [
							...o.agent.comments
						  , {
								userID: o.login.userID
							  , auto: true, body: 'Change rating'
							  , date: new Date().valueOf()
							  , value: value
							}
						]
				})
			}
		/>

		{(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
			<div
				style={{width: "calc(100% - 32px)", marginLeft: "16px", marginTop: "32px"}}
			>
				<RaisedButton
					backgroundColor="#3cd2ae"
					labelColor="#FFF"
					label="OK"
					fullWidth={true}
					style={{
						height: "40px"
					  , borderRadius: "4px"
					}}
					onClick={()=> o.setState("")}
				/>
			</div>:""

		}

	</div>
)



// WEBPACK FOOTER //
// ./src/routes/manager/agentForm/GeneralBlock.js